import React, { useState, useEffect } from "react";
import Catalogue from "./ProductCatalogue/Catalogue";
import { useParams } from "react-router-dom";
import axios from "axios";

const SignatureLookPages = () => {
  const [loading, setLoading] = useState(true);
  const [signatureLook, setSignatureLook] = useState(null);
  const { name } = useParams();

  useEffect(() => {
    let isActive = true;

    const getSignatureLook = async () => {
      setLoading(true);
      setSignatureLook(null);
      try {
        const response = await axios.get(
          `/api/signatureLook/getOne/${encodeURIComponent(name)}`
        );
        if (isActive) {
          setSignatureLook(response.data.signatureLook);
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
        if (isActive) {
          setLoading(false);
        }
      }
    };

    if (name) {
      getSignatureLook();
    }

    // Avoid setting state on an unmounted/old render when the look changes fast
    return () => {
      isActive = false;
    };
  }, [name]);

  const titleText = (
    <div>
      <p>{signatureLook?.description}</p>
    </div>
  );

  return (
    <>
      {loading && <div>Loading...</div>}
      {!loading && signatureLook && (
        <div>
          <Catalogue
            key={signatureLook.name}
            title={signatureLook.name}
            titleText={titleText}
            titleImage={""}
            category={""}
            signatureLook={signatureLook.name}
          />
        </div>
      )}
    </>
  );
};

export default SignatureLookPages;
